import React from "react";
import { useQuickSightS3  } from "@/hooks/useS3Reports";

const QuickSightAwsS3Dashboard = () => {
  const { embedUrl } = useQuickSightS3 ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsS3Dashboard;
